export default "__VITE_ASSET__Nv5SvmB4__"